<div class="academics-container">
  <div class="container">
    <h1 [@slideInUp]="slideInUp">Academics & Internship</h1>
    <div class="academics-flex">
      <div [@jello]="jello" class="flex-item">
        <h2>Internship</h2>
        <h3>Full Stack Web Development</h3>
        <h4>Glosys Technology Solutions Pvt Ltd</h4>
        <div class="tech-flex">
          <img src="../../../assets/angular.png" class="tech-item" alt="" srcset="">
          <img src="../../../assets/nodejs.png" class="tech-item" alt="" srcset="">
          <img src="../../../assets/TF_FullColor_Icon.png" class="tech-item" alt="" srcset="">
        </div>
        <p>Learn to work with REST APIs and built a strong foundational
          understanding of web development and developed a
          e-commerce site with ethereum block chain</p>
      </div>
      <div [@jello]="jello" class="flex-item">
        <h2>Education</h2>
        <h3>Bachelor in Electronics &
          Communication Engineering</h3>
        <h4>Rmk College of Engineering and Technology</h4>
        <p>Learned to work with electronics and studied about various antennas
          and their use cases and experimented a line follower bot with
          arduino nano</p>
      </div>
    </div>
  </div>
</div>
